import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { AuthContext } from 'context/authContext';
import { useContext } from 'react';

export default function useGetEmployeeFamilyInfo() {
  const { authState } = useContext(AuthContext);
  return useQuery(['get-employee-family-info'], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.EMPLOYEE_FAMILY_DETAILS_API, {
        employee_id: authState?.employee_id,
      })
    );
    return res.data;
  });
}
